import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

// 選択行から確定対象の shift_truck_id を集める。
// shift_truck_id は RotationRow.source.deliveryId（= delivery.id = shift_truck.id）。
// 同一 shift_truck の複数回転は同じ deliveryId になるため uniq し、二重送信を防ぐ。
// 合成行（固定ルート由来の placeholder / 回転追加）は実 shift_truck ではない。
// isPlaceholderRow フラグに加え、負値 deliveryId(<=0) も除外する（フラグを持たない合成行への防御）。
export function collectSelectedShiftTruckIds(
  selectedRowIds: Set<string>,
  rowGroups: VehicleRowGroup[],
): number[] {
  const ids = new Set<number>();
  for (const grp of rowGroups) {
    for (const row of grp.rows) {
      if (!selectedRowIds.has(row.rowId)) continue;
      if (row.source.isPlaceholderRow || row.source.deliveryId <= 0) continue;
      ids.add(row.source.deliveryId);
    }
  }
  return [...ids];
}

// 選択した shift_truck 群が全て fixed か。空集合は false（＝確定へ倒す）。
export function areAllFixed(shiftTruckIds: number[], fixedShiftTruckIds: Set<number>): boolean {
  if (shiftTruckIds.length === 0) return false;
  return shiftTruckIds.every((id) => fixedShiftTruckIds.has(id));
}

// 次に送る fixed 値。全て fixed なら解除(false)、そうでなければ確定(true)。
export function decideNextFixed(shiftTruckIds: number[], fixedShiftTruckIds: Set<number>): boolean {
  return !areAllFixed(shiftTruckIds, fixedShiftTruckIds);
}
